<div class="white-box technical-issues">
  <p>{{ (kind === '3a' ? 'EVE2.reportingPause.title_3a' : 'SHARED.technicalIssues.heading') | translate }}</p>
  <p>{{ (kind === '3a' ? 'EVE2.reportingPause.description_3a' : 'SHARED.technicalIssues.message') | translate }}</p>
</div>
